// extracted by mini-css-extract-plugin
module.exports = {"icon":"ShapeButton_icon__17IRY"};